import React from "react";
import "./skip-navigation.scss";

/**
 * SkipNavigation component for WCAG 2.4.1 compliance
 * Provides a keyboard-accessible link to skip past repetitive navigation
 * to the main content area.
 *
 * The link is visually hidden until it receives keyboard focus, at which
 * point it becomes visible at the top of the page.
 */
const SkipNavigation = () => {
  const handleSkipToMain = (e) => {
    e.preventDefault();
    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      // Set focus to the main content area
      mainContent.focus();
      // Scroll to main content if needed
      mainContent.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <a
      href="#main-content"
      className="skip-navigation"
      onClick={handleSkipToMain}
    >
      Skip to main content
    </a>
  );
};

export default SkipNavigation;
